import { Component, ViewEncapsulation, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'ap-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [NgClass]
})
export class ApPanelComponent {
    /**
     * Type of styling of panel component.
     * Possible values are: `primary` | `secondary` | `tertiary`.
     * Defaults to `primary`
     */
    public readonly type = input<'primary' | 'secondary' | 'tertiary'>('primary');

    /**
     * Input for the panel title
     */
    public readonly title = input<string>();
}
